import { LAB_CAT_CATEGORIES_ITEM } from './lab-cat-categories.js'

/** @type {import('../help-index.js').HelpScreen} */
export const LAB_CAT_HELP = {
  screenId: 'lab-cat',
  label: 'Categorías',
  navPath: 'Laboral → Categorías',
  keywords: [
    'categoría', 'categoría empleado', 'convenio', 'básico', 'sueldo básico', 'antigüedad',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Categorías laborales con tipo de sueldo, valor básico y % de antigüedad. Se asignan a cada empleado y alimentan la liquidación.',
  sidebarItems: [LAB_CAT_CATEGORIES_ITEM],
}
